<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span v-if="questionId!=null && questionId!='' && questionId!='new'">Асуулт засах</span>
                      <span v-else>Асуулт нэмэх</span>
                      
                    </h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <input v-model.trim="question.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Хичээлийн нэр">
                    </div>
                    <div class="form-group">
                      <textarea v-model.trim="question.description" type="text" class="form-control" id="exampleInputPassword" placeholder="Дэлгэрэнгүй" rows="10"/>
                    </div>
                    <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input type="checkbox" class="custom-control-input" id="customCheck" v-model="question.multichoice">
                        <label class="custom-control-label" for="customCheck">Олон хариулттай эсэх</label>
                      </div>
                    </div>
                    
                    <div class="form-group">
                      <div class="btn btn-success btn-small" v-on:click="addAnswer">Хариулт нэмэх</div>
                      <div v-if="answers!=null && answers.length>0" >
                        <div class="row my-3"  v-for="(answer,index) in answers" v-bind:key="'answer_'+index">
                          <div class="col col-8">
                            <textarea  v-model.trim="answer.name" type="text" class="form-control" placeholder="Хариулт"/>
                          </div>
                          <div class="col col-2 ">
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input"  v-model="answer.correct">
                                <label class="form-check-label" for="exampleCheck1">Зөв хариулт</label>
                              </div>
              
                          </div>
                          <div class="col col-auto">
                              <div>устгах</div>
              
                          </div>
                        </div>
                      </div>
                      <div v-else class="alert alert-danger">Одоогоор хариулт оруулаагүй байна.</div>
                    </div>
              
                    
                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
    name: "QuestionAdd",
    data() {
        return {
            question: {
                name: '',
                description: '',
                multichoice:false,


            },

            answers:[],
            tmpAnswer:{
                'name':'',
                'correct':false
            },
        };
    },
    methods: {
        save() {
            this.performingRequest = true
            if(this.question!=null && this.question.name!='' && this.question.description!=''){
                this.question.userId=this.$store.getters.currentUser.uid;
                this.question.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                this.question.createdAt=new Date()
                this.question.lectureCode=new Date().getTime()
                var docRef
                if(this.questionId!=null && this.questionId!='' && this.questionId!='new'){
                   docRef=fb.db.collection("asuulga/"+this.qaId+"/questions/").doc(this.questionId)
                   docRef.set(this.question)
                  this.answers.forEach(answer=>{
                    if(answer.id!=null && answer.id!='' && answer.id!=undefined)
                      docRef.collection("answers").doc(answer.id).set(answer)
                    else
                      docRef.collection("answers").doc().set(answer)
                  })
                }
                else{
                  docRef=fb.db.collection("asuulga/"+this.qaId+"/questions/").doc()
                  docRef.set(this.question)
                  // var lessonRef=docRef.parent.parent
                  // lessonRef.update({
                  //   'numberOfQuestions':fb.firestore.FieldValue.increment(1)
                  // }
                  // )
                  this.answers.forEach(answer=>{
                    docRef.collection("answers").doc().set(answer)
                  })
                }
                 
       
                 
                this.$router.back();
            }
        },
        setLesson(){
          this.question={
                name: '',
                description: '',
                multichoice:false,
                answers:[]  

            }
        },
        addAnswer(){
          this.answers.push({
                'name':'',
                'correct':false
            })
        },
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        }
        ,
        _getQA(){
          if(this.questionId!=null && this.questionId!=''){
            var docRef=fb.db.collection("asuulga/"+this.qaId+"/questions/").doc(this.questionId).get().then(doc=> {
                this.question=doc.data()
                doc.ref.collection("answers").get().then(querySnapshot=>{

                  querySnapshot.forEach(answer=> {
                      let object=answer.data()
                      object.id = answer.id
                      this.answers.push(object);
                  });
                })
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });

          }
        }
    },
    props: {
        questionId: { 
            required: false,
        },
        qaId: { 
            required: true,
        },
       
    
    },
    created() {
      if(this.questionId!=null && this.questionId!='' && this.questionId!='new'){
        this._getQA()
      }
    },
};
</script>

